/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

interface StatusLedProps {
  greenStatusName?: string;
  redStatusName?: string;
  yellowStatusName?: string;
  greyStatusName?: string;
  status: any;
}
export default function StatusLed(props: StatusLedProps) {
  const statuses: any = {};
  statuses[props.greenStatusName || 'ok'] = 'led-green';
  statuses[props.redStatusName || 'error'] = 'led-red';
  statuses[props.yellowStatusName || 'warn'] = 'led-yellow';
  statuses[props.greyStatusName || 'unknown'] = 'led-grey';

  const statusClass = statuses[props.status] || statuses.redStatusName;
  return <span className={`led ${statusClass}`}></span>;
}
